
export const CLEAR_PLANS_REDUX_VALUE = 'CLEAR_PLANS_REDUX_VALUE';

export const clearPlansReduxValue = () => ({
	type: CLEAR_PLANS_REDUX_VALUE,
});

export const CLEAR_BILLING_SUMMARY_REDUX_VALUE = 'CLEAR_BILLING_SUMMARY_REDUX_VALUE';

export const clearBillingSummaryReduxValue = () => ({
	type: CLEAR_BILLING_SUMMARY_REDUX_VALUE,
});
